import { atom } from 'jotai';

export const isSidebarCompareOpen = atom<boolean>(false);
